module.exports = __webpack_public_path__ + "img/fauteuil-25.229b93ce.jpg";